<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
            <el-upload
                ref="qweUpload"
                :class="disabledClass"
                :action="action"
                :data = "uploadData"
                :disabled= "disabled"
                :on-success="onSuccess"
                :on-error="onError"
                :before-remove="beforeRemove"
                :on-preview="onPreview"
                :multiple="isMultiple"
                name="files"
                :file-list="data[name] || []">
                <template #default>
                    <el-button size="default" type="primary" :disabled="disabled">点击上传</el-button>
                </template>
                <template #tip>
                    <div class="el-upload__tip">
                        {{ hint }}
                    </div>
                </template>
            </el-upload>
        </el-form-item>
    </el-col>
</template>

<style>
    .disableUpload i.el-icon.el-icon--close{
        display: none;
    }
</style>

<script>
    import baseAttachFileField from "./BaseAttachFileField" 
    import { MediaType } from "."
    import { Document } from '@element-plus/icons-vue'
    export default {
        name:"AttachFileField",
        mixins:[baseAttachFileField],
        components:{
            'document':Document
        },
        data:function(){
            return {
                mediaType:"",
                mediaTypeAccept:""
            }
        },
        created:function(){
            if(!this.selfSetting.hasOwnProperty("MediaType")){
                this.mediaType = MediaType.All
            }
            else{
                this.mediaType = this.selfSetting.MediaType;
            }
            switch(this.mediaType){
                case MediaType.All:
                    this.mediaTypeAccept = "";
                    break;
                case MediaType.Audio:
                    this.mediaTypeAccept = "audio/*";
                    break;
                case MediaType.Video:
                    this.mediaTypeAccept = "video/*";
                    break;
            }
        },
        mounted:function(){
            this.$refs.qweUpload.$refs.uploadRef.$refs.inputRef.setAttribute("capture",true)
        }
    }
</script>